var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.3333H22.6667V8.66667C22.6667 4.98667 19.68 2 16 2C12.32 2 9.33333 4.98667 9.33333 8.66667V11.3333H8C6.53333 11.3333 5.33333 12.5333 5.33333 14V27.3333C5.33333 28.8 6.53333 30 8 30H24C25.4667 30 26.6667 28.8 26.6667 27.3333V14C26.6667 12.5333 25.4667 11.3333 24 11.3333ZM16 23.3333C14.5333 23.3333 13.3333 22.1333 13.3333 20.6667C13.3333 19.2 14.5333 18 16 18C17.4667 18 18.6667 19.2 18.6667 20.6667C18.6667 22.1333 17.4667 23.3333 16 23.3333ZM12 11.3333V8.66667C12 6.45333 13.7867 4.66667 16 4.66667C18.2133 4.66667 20 6.45333 20 8.66667V11.3333H12Z",
    fill: "#133155"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock.5d19f2d0.svg";
export { ForwardRef as ReactComponent };